<template>
  <div>
    清除成功
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  },
  created() {
    window.localStorage.removeItem('huozhewang_userInfo')
    window.localStorage.removeItem('huozhewang_token')
    window.localStorage.removeItem('huozhewang_openId')
    window.localStorage.removeItem('hzUseRInfo')
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
